module.exports = __webpack_public_path__ + "fa80669c4eda16cd3e893e45eeafe040.jpg";